import {
  AppLayout,
  ButtonDropdownProps,
  TopNavigation,
  SideNavigation,
  Badge,
  PropertyFilter,
  Button,
  SideNavigationProps,
  TopNavigationProps,
  Alert,
  Toggle,
} from "@cloudscape-design/components";
import {
  applyMode,
  applyDensity,
  Mode,
  Density,
} from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext, useCallback } from "react";
import { Outlet, NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import "./App.css";
import * as awsui from "@cloudscape-design/design-tokens";
import logo from "./images/header_logo.png";
import headerLogoLight from "./images/frg-header-logo-light.png";
import headerLogoDark from "./images/frg-header-logo-dark.png";
// import footerLogoLight from "./images/footer_dark.png";
// import footerLogoDark from "./images/footer_light.png";
import footerLogoLight from "./images/frg-footer-logo-dark.png";
import footerLogoDark from "./images/frg-footer-logo-light.png";
// import dataApi from "./dataApi";
import sideNavMenu from "./sideNavMenu";
import { series } from "./dataTypes";
import { GlobalContext, ContentContext, ContentContextProvider } from "./context";
import { useUpdateEffect } from 'usehooks-ts' // https://usehooks-ts.com/react-hook
import { applyTheme } from "@cloudscape-design/components/theming";
import { cloudScapeTheme as theme } from "./theme";
import '@cloudscape-design/global-styles/dark-mode-utils.css';
import { useMediaQuery } from 'react-responsive'
import { Amplify } from 'aws-amplify';
import { useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import awsExports from './aws-exports';
import TopNav from "./components/navbar/topnav";
import ScrollToTop from "./components/scroll-to-top";


awsExports.oauth.domain = "auth.formularacinggroup.au";
Amplify.configure(awsExports);

const { reset } = applyTheme({ theme });

const i18nStrings = {
  searchIconAriaLabel: "Search",
  searchDismissIconAriaLabel: "Close search",
  overflowMenuTriggerText: "More",
  overflowMenuTitleText: "All",
  overflowMenuBackIconAriaLabel: "Back",
  overflowMenuDismissIconAriaLabel: "Close menu",
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { 
    theme, setTheme, 
    activeHref, setActiveHref,
    density, setDensity 
  } = useContext(GlobalContext);
  const { 
    activeSeriesName, setActiveSeriesName,
    activeSeriesRef, setActiveSeriesRef, 
    } = useContext(ContentContext);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  const { authStatus } = useAuthenticator(context => [context.authStatus]); // https://ui.docs.amplify.aws/react/connected-components/authenticator/advanced
  
  const [isVisible, setVisibleState] = useState(false);
  const [hideSideNav, setHideSideNav] = useState<boolean>(true);
  const hide = () => setVisibleState(false);

  useEffect(() => {
    applyMode(theme);
  }, [theme]);
  
  useEffect(() => {
    applyDensity(density);
  }, [density]);

  const isDesktopScreen: boolean = useMediaQuery({query: '(min-width: 1224px)'})

  const settingsActions = [
    {
      id: "darkmode",
      text: "Swap to " + (theme === Mode.Light ? "dark" : "light") + " mode",
    },
    {
      id: "compactmode",
      text:
        "Swap to " +
        (density === Density.Comfortable ? "compact" : "comfortable") +
        " mode",
    },
    {
      id: "side-nav",
      text: `${hideSideNav === true ? "Show" : "Hide"} side navigation`, 
    },
  ];

  const navItems = [
    { id: "home", text: "Home", href: "/", disabled: false },
    { id: "news", text: "News", href: "/news", disabled: false },
    { id: "media", text: "Media", href: "/media", disabled: false },
    { id: "merchandise", text: "Merchandise", href: "/merchandise", disabled: false },
    { id: "sponsors", text: "Sponsors", href: "/sponsors", disabled: false },
    { id: "about", text: "About", href: "/about", disabled: false },
    {
      id: "series-group",
      text: "Series",
      items: [
        { id: "f3a", text: "F3A", href: "/f3a-series" },
        { id: "f4a", text: "F4A", href: "/f4a-series" },
        { id: "s5000", text: "S5000", href: "/s5000-series" },
        { id: "ffa", text: "Formula Ford", href: "/ffa-series" },
        { id: "apjc", text: "Asia Pacific Junior Esports Challenge", href: "/apjc-series" },
      ]
    },
  ]

  if (isVisible) {
    settingsActions.push({
      id: "installFrgApp",
      text: "Install FRG App",
    })
  }

  // const UnderDevAlert = () => {
  //   if (showAlert){
  //     return (
  //       <Alert
  //       statusIconAriaLabel="Info"
  //       header="Under Development"
  //       type="info"
  //       action={<Button onClick={() => {setShowReportIssueModal(true)}}>Report Issue</Button>}
  //       dismissible
  //       onDismiss={ (event) => {
  //         setShowAlert(false)
  //       }}
  //     >
  //       The FRG website is under active development with new components are being released in daily builds. Please report any issues to FRG adminstrators. 
  //     </Alert>
  //     )
  //   }
  //   return <></>
  // }
  

  return (
    <>
      <div className="top-nav-bar">
        <TopNav />
      </div>
      <AppLayout
        stickyNotifications={true}
        toolsHide
        headerSelector={"top-nav-bar"}
        contentType="default"
        footerSelector="#footer"
        // navigation={}
        disableContentPaddings
        navigationHide={hideSideNav}
        maxContentWidth={900}
        navigationWidth={250}
        content={
          <ContentContextProvider>
            <ScrollToTop>
              <Outlet />
            </ScrollToTop>
          </ContentContextProvider>
        }
      />
      <div
        id="footer"
        style={{
          position: "sticky",
          backgroundColor: awsui.colorBackgroundCellShaded,
          color: awsui.colorTextBodyDefault,
          borderTopWidth: "1px",
          borderTopStyle: "none",
          borderTopColor: awsui.colorBorderDropdownItemHover,
          textAlign: "center",
          padding: "10px",
          left: "0",
          bottom: "0",
          // height: "20px",
        }}
      >
        <img
          src={theme === Mode.Light ? footerLogoLight : footerLogoDark}
          alt="Formula Racing Group"
          height="35px"
        />
      </div>
    </>
  );
}

export default App;
